



































































































































import Vue from "vue";
import { mapGetters } from "vuex";
import { startLogin, handleUser } from "@/lib/auth";
import firebase from "firebase/app";
import { FromError } from "../lib/error";
import Icon from "../assets/iconsMedia/reply-medium.svg";
import ReplyIcon from "../assets/iconsMedia/replay-by-ipcom.svg";
let unsub: firebase.Unsubscribe;

export default Vue.extend({
  components: {
    Icon,
    ReplyIcon,
  },
  data() {
    return {
      showPassword: false,
      emailLogin: false,
      email: "",
      password: "",
      splash: true,
      error: null as any,
      showError: false,
      release: "1.0.0",
    };
  },
  mounted() {
    if (process.env.VUE_APP_RELEASE) {
      this.release = process.env.VUE_APP_RELEASE;
    }
  },
  watch: {
    error(nv) {
      if (nv) {
        this.showError = true;
      }
    },
    showError(nv) {
      if (!nv) {
        this.error = null;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    errorInfo(): string {
      if (!this.error) {
        return "";
      }
      return this.error.UserMessage ?? this.error.message ?? "";
    },
  },
  created() {
    unsub = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        handleUser(user)
          .then((res) => {
            this.$store.commit("auth/SET_USER", res);
            this.$store.commit(
              "auth/SET_ROLES",
              res.user?.customerCurrent.role
            );
            this.$router.push("/");
          })
          .catch((err) => {
            return FromError(err)
              .then((err) => {
                this.error = err;
              })
              .finally(() => {
                firebase.auth().signOut();
              });
          });
      } else {
        this.splash = false;
      }
    });
    this.waitForUser();
  },
  destroyed() {
    if (unsub) {
      unsub();
    }
  },
  methods: {
    waitForUser() {
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(() => firebase.auth().getRedirectResult())
        .catch((err) => {
          FromError(err).then((err) => {
            this.error = err;
          });
        });
    },
    requestPasswordReset() {
      this.$router.push("/requestPasswordReset");
    },
    loginEmail() {
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(() =>
          firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        )
        .catch((err) => {
          FromError(err).then((err) => {
            this.error = err;
          });
        });
    },

    loginWithGoogle() {
      startLogin("google").catch((err) => {
        FromError(err).then((err) => {
          this.error = err;
        });
      });
    },
  },
});
